
import NavAll from './components/navbottom/NavAll.vue'
import CartFloatEntry from './components/common/CartFloatEntry.vue'
import FloatingAssistant from './components/common/FloatingAssistant.vue'

window.onload = function () {
  document.addEventListener('touchstart', function (event) {
    if (event.touches.length > 1) {
      event.preventDefault()
    }
  })
  document.addEventListener('gesturestart', function (event) {
    event.preventDefault()
  })
}

export default {
  name: 'LayoutDefault',
  components: {
    NavAll,
    CartFloatEntry,
    FloatingAssistant
  },
  data () {
    return {
      leftDrawerOpen: false
    }
  },

  computed: {
    isSearch () {
      return this.$route.meta.navShow
    },

    isNopage () {
      return this.$route.meta.noPageShow !== false
    }
  },
  created () {
    console.log('%c三( ᐛ )੭ Welcome To The PratoOS!', 'color:#FFAA00; ')
    // 导航逻辑统一在 router.beforeEach 处理
    // App.vue 只负责初始化数据
  }
}
